import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { 
  Typography, 
  TextField, 
  MenuItem,
  Button,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const SettlementToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    user_role,
    type,
    advertises,
    // agencies,
    // clients,
    agencies,
    clients,
    selectedAgency, 
    onChangeAgency,
    selectedClient,
    onChangeClient,
    onClickFindAdverties,
    ...rest
 } = props;

  const classes = useStyles();

  // const [selectedAgency, setSelectedAgency] = useState('');
  // const [selectedClient, setSelectedClient] = useState('');

  // const handleChangeAgency = e => {
  //   setSelectedAgency(e.target.value);
  // };

  // const handleChangeClient = e => {
  //   setSelectedClient(e.target.value);
  // };


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>

        { user_role !== 'client' && (
          <>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              광고대행사
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="id-find-agency"
              select
              value={selectedAgency}
              //onChange={handleChangeAgency}
              onChange={e => onChangeAgency(e)}
              //variant="outlined"
              margin="dense"
            >
              {agencies.map(agency => (
                <MenuItem key={agency.name} value={agency.name}>
                  {agency.name}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          광고주
        </Typography>
        <TextField
          className={classes.registerListItemInput}
          id="id-find-client"
          select
          value={selectedClient}
          //onChange={handleChangeClient}
          onChange={e => onChangeClient(e)}
          //variant="outlined"
          margin="dense"
        >
          {clients.map(client => (
            <MenuItem key={client.name} value={client.name}>
              {client.name}
            </MenuItem>
          ))}
        </TextField>

        <Button
          color="primary"
          variant="contained"
          onClick={ () => onClickFindAdverties(selectedAgency, selectedClient) }
        >
          조회
        </Button>

      </div>
         
    </div>
  );
};

SettlementToolbar.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  companies: PropTypes.array.isRequired,
  agencies: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired
};

SettlementToolbar.defaultProps = {
  companies: [],
  agencies: [],
  clients: []
};

export default SettlementToolbar;
